export default __webpack_public_path__ + "locales/si/ConnectDialog.json?hash=5798985d8dfd87a4489cba6b36fd89c7";